import { Outlet, createFileRoute } from "@tanstack/react-router";
import queryClient from "api/queryClient.ts";
import { getIntegrationQueryOptions } from "api/TenantSlug/Integration/queryOptions.ts";
import { QueryState } from "components/UI/QueryState/QueryState.tsx";

export const Route = createFileRoute(
    "/_authenticated/$tenantSlug/_layout/tool/_layout/scenario/_layout/integration/_layout/$integrationId/_layout"
)({
    loader: async ({ params: { integrationId } }) => {
        let breadcrumb = integrationId;

        try {
            const { integration } = await queryClient.ensureQueryData(getIntegrationQueryOptions(integrationId));

            breadcrumb = integration.name;
        } catch (e) {
            console.error(e);
        }

        return {
            breadcrumb,
        };
    },
    pendingComponent: () => <QueryState isLoading={true} isError={false} />,
    errorComponent: () => <QueryState isLoading={false} isError={true} errorKey="errors.loading_integration" />,
    component: () => <Outlet />,
});
